import * as React from 'react';
export const IcBakery = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.68 19.13l-.68-.56a.63.63 0 01-.17-.73 15.43 15.43 0 000-11.68.63.63 0 01.17-.73l.62-.52a1.093 1.093 0 000-1.55A1.14 1.14 0 0019.9 3H4.1a1.1 1.1 0 00-.78 1.87l.68.56a.63.63 0 01.17.73 15.43 15.43 0 000 11.68.63.63 0 01-.17.73l-.62.52a1.09 1.09 0 000 1.55c.188.204.444.331.72.36h15.8a1.1 1.1 0 00.78-1.87zM11 17h-.05A2.713 2.713 0 018 14.5a3.53 3.53 0 010-.5 2.722 2.722 0 013 2.5c.012.166.012.334 0 .5zm0-4h-.05A2.713 2.713 0 018 10.5a3.53 3.53 0 010-.5 2.72 2.72 0 013 2.5c.012.166.012.334 0 .5zm1-2a1.927 1.927 0 01-.33-.31A2.5 2.5 0 0112 7c.12.09.23.19.33.3A2.49 2.49 0 0112 11zm1 6a3.496 3.496 0 010-.46A2.719 2.719 0 0116 14c.01.153.01.307 0 .46A2.71 2.71 0 0113.06 17H13zm0-4a3.496 3.496 0 010-.46A2.719 2.719 0 0116 10c.01.153.01.307 0 .46A2.71 2.71 0 0113.06 13H13z'
      fill='currentColor'
    />
  </svg>
);
